import { useFetch } from 'app/queryProvider';
import { TComplianceScores } from '../entities';

export const useComplianceScores = (pathwayId?: string, options?: { enabled?: boolean }) => {
  return useFetch<TComplianceScores>({
    queryKey: [['pathway', 'compliance-scores', pathwayId ?? '']],
    url: '/compliance-scores',
    resource: { name: 'pathways', id: pathwayId },
    options: {
      enabled: (options?.enabled ?? true) && !!pathwayId,
    },
  });
};
